export const PDF_CAPTURE_SCALE = 2.5;
export const PDF_IMAGE_QUALITY = 0.88;
export const PDF_EXPORT_EXTRA_STEPS = 3;

/**
 * รวมจำนวนหน้าที่ต้องแปลงกับขั้นตอนท้ายงาน export
 *
 * ใช้เป็น denominator เดียวกันทั้งตอนเริ่มงานและตอนแสดง progress
 * เพื่อไม่ให้เปอร์เซ็นต์ค้างใกล้ 100 ทั้งที่กำลัง upload หรือ save อยู่
 */
export const getPdfExportTotalSteps = (pageCount = 0) => {
  const normalizedPageCount = Number.isFinite(Number(pageCount))
    ? Math.max(0, Number(pageCount))
    : 0;

  return normalizedPageCount + PDF_EXPORT_EXTRA_STEPS;
};

/**
 * แปลงจำนวนขั้นตอนที่ทำเสร็จเป็นข้อความเปอร์เซ็นต์แบบ bounded
 *
 * progress จาก browser อาจเกินหรือต่ำกว่า range ได้จาก retry หรือ state เก่า
 * จึง clamp ไว้ที่ 0-100 ก่อน format เพื่อให้ข้อความบนปุ่มตรงกับสถานะจริง
 */
export const getPdfExportProgressPercent = (progress = 0, totalSteps = 0) => {
  if (!totalSteps) return "0.00";

  const percent = (Number(progress || 0) / Number(totalSteps)) * 100;
  const boundedPercent = Math.min(100, Math.max(0, percent));

  return boundedPercent.toFixed(2);
};
